import React, { useCallback } from 'react'

import { Button } from '@refera/ui-web'

import { ROUTES } from '_/utils/constants'
import { navigate, useLocation, useParams } from '@reach/router'
import useRolePermission from '_/hooks/use-role-permission'
import { useSelector } from 'react-redux'
import { getBudgetByIdSelectorJS } from '_/modules/budget/selectors'
import { useDialog } from '_/hooks/use-dialog'
import { useToast } from '_/hooks/use-toast'
import { verifyBudget, verifyBudgetFromPath } from '_/utils/verify-budget'
import { PERMISSIONS, PERMISSIONS_ACTIONS } from '_/utils/constants/permissions'

export default function ManageServicesButton() {
  const { checkUserPermission } = useRolePermission()
  const { pathname } = useLocation()
  const { serviceOrderId, budgetId } = useParams()
  const { showDialog, closeDialog } = useDialog()
  const { showToast } = useToast()
  const budget = useSelector(getBudgetByIdSelectorJS(budgetId))
  const { budgetIsInternal } = verifyBudget(budget)
  const { budgetIsSaved } = verifyBudgetFromPath(pathname)

  // Verifica se o usuário tem permissão para gerenciar serviços do orçamento
  const showButton = budget?.isOriginal !== true

  const handleButtonClick = useCallback(() => {
    if (!budgetIsSaved) {
      // Message 5
      return showDialog({
        type: 'warning',
        subject: 'Atenção',
        description: 'Salve antes as edições deste registro.',
        onApprove: closeDialog,
        labelApprove: 'Ok, entendi',
      })
    }
    if (!budgetIsInternal) {
      // Message 591
      return showToast({
        message: 'Esta ação só é aceita para editar orçamentos internos.',
        type: 'error',
      })
    }

    return navigate(
      `${ROUTES.SERVICE_ORDER}/${serviceOrderId}/servicos?budgetId=${budgetId}&novoOrcamento=true`
    )
  }, [navigate, serviceOrderId, budgetId, budgetIsInternal, budgetIsSaved])

  if (!showButton) return null

  return (
    <Button
      onClick={() =>
        checkUserPermission({
          permission: PERMISSIONS.BUDGET_SERVICES,
          permissionAction: PERMISSIONS_ACTIONS.ADD,
          functionAccess: handleButtonClick,
        })
      }
      color="primary"
      variant="secondary"
    >
      Gerenciar serviços
    </Button>
  )
}
